//['WkDy Reg', 'WkDy CPH Group', 'Sat']

export const modifyState = () => {
  return { 
    account: null,
    ignoreTheseAlerts: [],
    scheduleLoading:false,
    selectedStopID:null,
    routeSchedules: {
      "WkDy Reg":{},
      "WkDy CPH Group":{},
      "Sat":{}
    },
  }
}
export const modifyMutations = () => {
  return {

    setScheduleLoading(state, loadingYesOrNo) {
      state.scheduleLoading = loadingYesOrNo
    },
    
    setSelectedStopID(state, selectedStopID) {
      state.selectedStopID = selectedStopID
    },

    setAccount(state, account) {
      state.account = account
    },

    addIgnoreAlertID(state, ignoreID) {
      state.ignoreTheseAlerts.push(ignoreID)
    },

    //payload has the routeID and the schedule
    addSchedule(state, { serviceID, routeID, schedule }) {
      state.routeSchedules[serviceID] = { ...state.routeSchedules[serviceID], [routeID]: schedule}
    },
  }
}
export const modifyActions = () => {
  return {
    setScheduleLoading({commit}, loadingYesOrNo) {
      commit("setScheduleLoading", loadingYesOrNo)
    },
    setAccount({commit}, account) {
      commit("setAccount", account)
    },
    //obj: { serviceID, routeID, schedule }
    addSchedule({commit}, obj) {
      commit("addSchedule", obj)
    },
    addIgnoreAlertID({commit}, ignoreID) {
      commit("addIgnoreAlertID", ignoreID)
    },
    setSelectedStopID({commit}, selectedStopID) {
      commit("setSelectedStopID", selectedStopID)
    }
  }
}
